import { EnvironmentInterface } from "../environment-interface";

export const environment: EnvironmentInterface = {
  production: true,
  envName: "teste",
  apiURL: "https://tst-gmen.idba.com.br/api-idba/",
  apiURLLogin: "https://tst-gmen.idba.com.br/api-idba/v3/authenticate/",
  apiURLChangePassword: "https://tst-gmen.idba.com.br/api-idba/v3/change-password/",
  apiURLIntegrate: "https://tst-gmen.idba.com.br/api-idba/v3/integrate/",
  envDesc: "Teste - Granja Menegon",
  timeout: 3000000,
  encryptionKey: "_iDB@Fram3w0rk_&Rp",
  classToolbar: "",
  imagemLogo: "",
  indLogoEmpresa: false,
  service: false,
  debugRoutes: false,
  passwordMinSize: 8,
  passwordMaxSize: 12,
  passwordValidateUppercase: true,
  passwordValidateLowercase: true,
  passwordValidateNumber: true,
  passwordValidateSpecialChar: true
};